import React from 'react';
import { TicketsPage } from './CreditSales';

export default function OneCardSales() {
  return <TicketsPage method="1Card" />;
}
